import { DeliverObjectDto, PhaseDto, ProjectMemberDto } from '../../api/model';
import { Deliverable } from '../../types/deliverables';
import { getPhaseDisplayName } from '../../utils/phaseUtils';
import { deliverableResponsible } from '../../utils/deliverableResponsible';

// Helper function to format date from LocalDate to display format
const formatDate = (localDate?: string): string => {
	if (!localDate) return '';
	const date = new Date(localDate);
	return date.toLocaleDateString('en-GB', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric'
	});
};

/** A deliverable as the table and its detail popup show it. */
export const convertToTableFormat = (deliverable: DeliverObjectDto, phaseType?: string, members?: ProjectMemberDto[]) => {
	return {
		id: deliverable.id?.toString() || '',
		name: deliverable.name || 'Unnamed Deliverable',
		phase: phaseType || 'Unknown Phase',
		criticality: deliverable.criticality,
		startDate: formatDate(deliverable.startDate),
		endDate: formatDate(deliverable.endDate),
		rawStartDate: deliverable.startDate || '',
		progress: deliverable.progress ?? 0,
        labels: deliverable.labels || [],
		responsible: deliverableResponsible(deliverable.responsibleUserId, members)
	};
};

/** Each of the project's deliverables with the display name of its phase. */
export function deliverablesWithPhase(
	projectDeliverables: DeliverObjectDto[],
	projectPhases?: PhaseDto[],
): Array<{ deliverable: DeliverObjectDto; phaseType: string }> {
	if (!projectPhases) return [];
	// map the phase id so look up is faster
	const phaseMap = new Map<number, string>();
	projectPhases.forEach(phase => {
		if (phase.id) {
			phaseMap.set(phase.id, getPhaseDisplayName(phase));
		}
	});

	return projectDeliverables.map((deliverable) => {
		const deliverableAny = deliverable as any;
		const phaseId = deliverableAny.phase_id || deliverableAny.phaseId;
		// Default phase name (or if the phase is unknown)
		return { deliverable, phaseType: phaseMap.get(phaseId) ?? 'Not Assigned' };
	});
}

/** The project's deliverables in table form - what the Deliverables page and its popup work with. */
export function deliverableTableRows(
	projectDeliverables: DeliverObjectDto[],
	projectPhases?: PhaseDto[],
	members?: ProjectMemberDto[],
): Deliverable[] {
	return deliverablesWithPhase(projectDeliverables, projectPhases).map(({ deliverable, phaseType }) =>
		convertToTableFormat(deliverable, phaseType, members),
	) as Deliverable[];
}
